import { render, staticRenderFns } from "./MonetaryStatusSelectBox.vue?vue&type=template&id=5bfb4b9c&scoped=true&"
import script from "./MonetaryStatusSelectBox.vue?vue&type=script&lang=js&"
export * from "./MonetaryStatusSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb4b9c",
  null
  
)

export default component.exports